var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { BaseTemplate } from "./base-template";
import { clientComponentModuleId } from "../render-engine/render-engine.helper";
import { activationStrategy } from "aurelia-router";
import { NotificationType } from "../../../services/basics/notification-client.service";
import { MobileHelper } from "../../../helpers/mobile-helper";
import * as Enumerable from "linq";
import { Client } from "../../../views/app/client/client";
import { TicketStatusEnum } from "../../../models/modules/lotteryplatofrm.models";
import { Guid } from "../../../utilities/guid";
import { RouterConstants } from "../../../configuration/router.constants";
import { computedFrom } from "aurelia-binding";
var BaseBundle = /** @class */ (function (_super) {
    __extends(BaseBundle, _super);
    function BaseBundle(lotteryClientService, router, tokenClient, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.lotteryClientService = lotteryClientService;
        _this.notificationClientService = notificationClientService;
        _this.eventAggregator = eventAggregator;
        _this.bindingSignaler = bindingSignaler;
        _this.gamePlayerTicketClientService = gamePlayerTicketClientService;
        _this.tickets = {};
        _this.removedTickets = {};
        _this.bonusNumbers = {};
        _this.mainNumbers = {};
        _this.drawnBonusNumbers = {};
        _this.drawnMainNumbers = {};
        _this.discountOffers = [];
        _this.bundleLotteries = [];
        _this.previewData = [
            {
                discount: 5,
                price: 2,
                draws: 2,
                numberOfDraws: 2
            },
            {
                discount: 10,
                price: 2,
                draws: 4,
                numberOfDraws: 4
            },
            {
                discount: 20,
                price: 2,
                draws: 8,
                numberOfDraws: 8
            },
            {
                discount: 30,
                price: 2,
                draws: 12,
                numberOfDraws: 12
            }
        ];
        _this.isLoadingTickets = true;
        _this.loadTickets = function () {
            var e_1, _a;
            if (_this.tokenClient.isPreview) { // for admin preview
                _this.isLoadingTickets = false;
                try {
                    for (var _b = __values(_this.bundleLotteries), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var lottery = _c.value;
                        var ticket = _this.getNewTicket();
                        _this.pickRandomInternal(ticket, lottery.brandLotteryId);
                        var tickets = [{
                                bonusPicks: ticket.bonus.join(','),
                                mainPicks: ticket.main.join(','),
                                ticketGuid: ticket.guid,
                                bundleGuid: _this.bundleGuid,
                                gamePlayerTicketLineId: ticket.ticketId,
                                brandLotteryId: lottery.brandLotteryId
                            }];
                        _this.setTickets(tickets, lottery.brandLotteryId);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            else {
                _this.gamePlayerTicketClientService.getBundleSavedTickets({
                    cartGuid: _this.cartGuid,
                    ticketStatus: _this.isFromCart ? TicketStatusEnum.AddedToCart : TicketStatusEnum.New,
                    bundleId: _this.bundle.bundleId
                }).then(function (x) {
                    var e_2, _a;
                    _this.isLoadingTickets = false;
                    try {
                        for (var _b = __values(_this.bundleLotteries), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var lottery = _c.value;
                            var tickets = x.tickets[lottery.brandLotteryId];
                            if (!tickets || tickets.length == 0) {
                                var ticket = _this.getNewTicket();
                                _this.pickRandomInternal(ticket, lottery.brandLotteryId);
                                tickets = [{
                                        bonusPicks: ticket.bonus.join(','),
                                        mainPicks: ticket.main.join(','),
                                        ticketGuid: ticket.guid,
                                        gamePlayerTicketLineId: ticket.ticketId,
                                        brandLotteryId: lottery.brandLotteryId
                                    }];
                            }
                            _this.setTickets(tickets, lottery.brandLotteryId);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    _this.checkSubscribeAndDefaultDiscount();
                    _this.updateTicketNumbers();
                }, function (x) {
                    _this.isLoadingTickets = false;
                    _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
                });
            }
        };
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        return _this;
    }
    BaseBundle.prototype.getNumberOfDraws = function () {
        var selectedOffer = this.getSelectedOffer();
        return selectedOffer.isMonthlySubscription ? selectedOffer.numberOfDraws : selectedOffer.numberOfDraws * this.bundle.bundleBrandLotteries.length;
    };
    BaseBundle.prototype.determineActivationStrategy = function () {
        return activationStrategy.replace;
    };
    Object.defineProperty(BaseBundle.prototype, "cssKey", {
        get: function () {
            return this.key ? this.key.replace(new RegExp("[']+"), '') : "";
        },
        enumerable: false,
        configurable: true
    });
    BaseBundle.prototype.activate = function (params) {
        var _this = this;
        var promise = _super.prototype.activate.call(this, params);
        this.key = params.key;
        if (params && params.cartGuid) {
            this.cartGuid = params.cartGuid;
        }
        if (params && params.bundleGuid) {
            this.bundleGuid = params.bundleGuid;
        }
        if (params && params.isFromCart) {
            this.isFromCart = params.isFromCart;
        }
        if (params) {
            this.bundleId = params.bundleId;
        }
        if (params && params.draws) {
            this.draws = params.draws;
        }
        if (params && params.canRevert) {
            this.canRevert = params.canRevert;
        }
        if (params && params.isFromAgent) {
            this.isFromAgent = params.isFromAgent;
        }
        var bundlePromise = this.lotteryClientService.getClientBundle({
            bundleId: this.bundleId
        }).then(function (bundleResult) {
            _this.bundle = bundleResult;
        }, function (x) {
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
        return new Promise(function (resolve, reject) { return Promise.all([promise, bundlePromise]).then(function (x) { return resolve(); }, reject); });
    };
    BaseBundle.prototype.attached = function () {
        var _this = this;
        _super.prototype.attached.call(this);
        this.countryId = this.tokenClient.getCountryId();
        this.userCurrency = this.tokenClient.getUserCurrency();
        this.loadBundleDetails();
        if (this.isFromAgent) {
            // first show page and then load dialog
            setTimeout(function () {
                _this.showClientDetailsDialog();
            });
        }
    };
    BaseBundle.prototype.detached = function () {
        _super.prototype.detached.call(this);
    };
    BaseBundle.prototype.selectOffer = function (item, persistDrawChanges) {
        var _this = this;
        if (persistDrawChanges === void 0) { persistDrawChanges = true; }
        this.discountOffers.forEach(function (x) { return x.isSelected = false; });
        item.isSelected = true;
        this.updateTotalPrice();
        // persist draw changes
        if (persistDrawChanges) {
            var ticketsToSave = {};
            for (var key in this.tickets) {
                var brandLotteryId = Number(key);
                var lottery = Enumerable.from(this.bundleLotteries).firstOrDefault(function (x) { return x.brandLotteryId == brandLotteryId; });
                var ticketsToSaveForLottery = Enumerable.from(this.tickets[key])
                    .where(function (x) { return _this.getRemainingBonus(x, brandLotteryId) != lottery.drawnBonusNumbers && _this.getRemainingMain(x, brandLotteryId) != lottery.drawnNumbers; })
                    .toArray();
                ticketsToSave[key] = ticketsToSaveForLottery;
            }
            this.saveBulk(ticketsToSave);
        }
    };
    BaseBundle.prototype.saveBulk = function (tickets, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        return new Promise(function (resolve, reject) {
            if (!_this.canRevert || force) {
                var requests = Enumerable.from(tickets).selectMany(function (x) {
                    var lotteryTickets = Enumerable.from(x.value).select(function (a) { return _this.getCreateTicketRequest(a, Number(x.key)); });
                    return lotteryTickets;
                }).toArray();
                var valid = Enumerable.from(requests).all(function (x) { return _this.validateRequest(x); });
                if (valid) {
                    _this.gamePlayerTicketClientService.createOrModifyTicketBulk(requests)
                        .then(function (x) { resolve(); })
                        .catch(function (x) {
                        _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
                        reject();
                    });
                }
                else {
                    reject();
                }
            }
            else {
                reject();
            }
        });
    };
    BaseBundle.prototype.quickPick = function () {
        var _this = this;
        for (var key in this.tickets)
            this.tickets[key].forEach(function (x) { return _this.pickRandomInternal(x, Number(key)); });
        this.saveBulk(this.tickets);
        this.updateTotalPrice();
    };
    BaseBundle.prototype.quickPickOne = function (ticket, brandLotteryId) {
        this.pickRandomInternal(ticket, brandLotteryId);
        this.save(ticket, brandLotteryId);
        this.updateTotalPrice();
    };
    BaseBundle.prototype.loadBundleDetails = function () {
        var e_3, _a;
        var _this = this;
        if (this.bundle && (this.bundleId || this.tokenClient.isPreview)) {
            var lotteryBrandDiscountsEnumerable = Enumerable.from(this.bundle.lotteryBrandDiscounts);
            //get the disounts filtered by country id match or null country
            this.discountOffers = this.tokenClient.isPreview ?
                this.previewData :
                lotteryBrandDiscountsEnumerable.orderBy(function (x) { return x.countryId; }).where(function (x) { return ((x.countryId == _this.countryId) || (x.countryId == null)); }).orderBy(function (x) { return x.numberOfDraws; }).toArray();
            //get ticket prices according to user country and currency of the user (order by lotteryJackpotRangeId so that those that have this set are selected first)
            var lotteryBrandPricesEnumerable = Enumerable.from(this.bundle.lotteryBrandPrices).orderByDescending(function (x) { return x.lotteryJackpotRangeId; });
            //find the current jackpot range so that we can choose the ticket price for that range 
            this.ticketPrice = this.tokenClient.isPreview ?
                {
                    currencyId: Enumerable.from(this.tokenClient.currencies).where(function (x) { return x.currencyCode && x.currencyCode.toLowerCase() == "eur"; }).select(function (x) { return x.currencyId; }).firstOrDefault(),
                    price: this.previewData[0].price
                } :
                this.getPrice(lotteryBrandPricesEnumerable);
            this.bundleLotteries = Enumerable.from(this.lotteries).where(function (x) { return _this.bundle.bundleBrandLotteries.map(function (a) { return a.brandLotteryId; }).indexOf(x.brandLotteryId) != -1; }).toArray();
            try {
                for (var _b = __values(this.bundleLotteries), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var lottery = _c.value;
                    this.mainNumbers[lottery.brandLotteryId] = Enumerable.range(lottery.drawMinimumNumber, (lottery.drawMaximumNumber + 1) - lottery.drawMinimumNumber).toArray();
                    this.drawnMainNumbers[lottery.brandLotteryId] = Enumerable.range(1, lottery.drawnNumbers).toArray();
                    if (lottery.drawnBonusMinimumNumber != null && lottery.drawnBonusMaximumNumber != null) {
                        this.bonusNumbers[lottery.brandLotteryId] = Enumerable.range(lottery.drawnBonusMinimumNumber, (lottery.drawnBonusMaximumNumber + 1) - lottery.drawnBonusMinimumNumber).toArray();
                        this.drawnBonusNumbers[lottery.brandLotteryId] = Enumerable.range(1, lottery.drawnBonusNumbers).toArray();
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            this.loadTickets();
            this.checkSubscribeAndDefaultDiscount();
            this.updateTicketNumbers();
            this.validateRequest(null);
        }
    };
    BaseBundle.prototype.setTickets = function (tickets, key) {
        var e_4, _a;
        this.tickets[key] = [];
        var ordered = Enumerable.from(tickets).orderBy(function (x) { return x.sequenceNumber; }).toArray();
        try {
            // set saved tickets
            for (var ordered_1 = __values(ordered), ordered_1_1 = ordered_1.next(); !ordered_1_1.done; ordered_1_1 = ordered_1.next()) {
                var item = ordered_1_1.value;
                var ticket = {
                    ticketId: item.gamePlayerTicketLineId,
                    guid: item.ticketGuid,
                    main: Enumerable.from(item.mainPicks.split(",")).where(function (x) { return x != "" && x != null; }).select(function (x) { return Number(x); }).toArray(),
                    bonus: Enumerable.from(item.bonusPicks.split(",")).where(function (x) { return x != "" && x != null; }).select(function (x) { return Number(x); }).toArray()
                };
                this.tickets[key].push(ticket);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (ordered_1_1 && !ordered_1_1.done && (_a = ordered_1.return)) _a.call(ordered_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        var brandLottery = this.bundle.bundleBrandLotteries.find(function (x) { return x.brandLotteryId == tickets[0].brandLotteryId; });
        var numberOfLines = brandLottery && brandLottery.numberOfLines ? brandLottery.numberOfLines : this.bundle.numberOfLines;
        var remainder = (this.tickets[key].length / numberOfLines) % 1;
        var remaining = numberOfLines - (remainder * numberOfLines);
        // add missing items in line
        if (remaining != numberOfLines || this.tickets[key].length == 0)
            for (var i = 1; i <= remaining; i++) {
                var ticket = {
                    guid: Guid.generateGuid(),
                    main: Enumerable.from(item.mainPicks.split(",")).where(function (x) { return x != "" && x != null; }).select(function (x) { return Number(x); }).toArray(),
                    bonus: Enumerable.from(item.bonusPicks.split(",")).where(function (x) { return x != "" && x != null; }).select(function (x) { return Number(x); }).toArray(),
                };
                this.tickets[key].push(ticket);
            }
    };
    BaseBundle.prototype.checkSubscribeAndDefaultDiscount = function () {
        var _this = this;
        var discount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return _this.draws && x.numberOfDraws == _this.draws; });
        var defaultDiscount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isDefault; });
        if (discount) {
            this.selectOffer(discount, false);
        }
        else if (defaultDiscount) {
            this.selectOffer(defaultDiscount, false);
        }
        else if (this.discountOffers[0]) {
            this.selectOffer(this.discountOffers[0], false);
        }
    };
    BaseBundle.prototype.getPrice = function (enumerable) {
        var _this = this;
        var query = enumerable.where(function (x) { return x.currencyId == _this.userCurrency.currencyId; });
        if (query.any(function (x) { return x.countryId == _this.countryId; }))
            query = query.where(function (x) { return x.countryId == _this.countryId; });
        else
            query = query.where(function (x) { return x.countryId == null; });
        query = query.where(function (x) { return x.lotteryJackpotRangeId == null; });
        return query.firstOrDefault();
    };
    BaseBundle.prototype.resetAll = function () {
        var _this = this;
        for (var key in this.tickets)
            this.tickets[key].forEach(function (x) { return _this.resetInternal(x, Number(key)); });
        this.saveBulk(this.tickets);
        this.updateTotalPrice();
    };
    BaseBundle.prototype.reset = function (ticket, key) {
        this.resetInternal(ticket, key);
        this.save(ticket, key);
    };
    BaseBundle.prototype.resetInternal = function (ticket, key) {
        ticket.main = [];
        ticket.bonus = [];
        this.updateTicketNumbers();
        this.removedTickets[key].push(ticket);
        if (MobileHelper.isMobileDevice() && this.shouldDeleteTicketOnMobile()) {
            var index = this.tickets[key].indexOf(ticket);
            this.tickets[key].splice(index, 1);
        }
    };
    BaseBundle.prototype.pickRandomInternal = function (ticket, key) {
        var numbersToPick = 0;
        var bonusToPick = 0;
        var lottery = this.getLotteryById(key);
        if (lottery.drawnNumbers === ticket.main.length) {
            ticket.main = [];
        }
        if (lottery.drawnBonusNumbers === ticket.bonus.length) {
            ticket.bonus = [];
        }
        numbersToPick = lottery.drawnNumbers - ticket.main.length;
        bonusToPick = lottery.drawnBonusNumbers - ticket.bonus.length;
        for (var i = 1; i <= numbersToPick; i++) {
            var number = 0;
            do {
                number = this.getRandom(lottery.drawMinimumNumber, lottery.drawMaximumNumber);
            } while (Enumerable.from(ticket.main).contains(number));
            ticket.main.push(number);
        }
        for (var i = 1; i <= bonusToPick; i++) {
            var number = 0;
            do {
                number = this.getRandom(lottery.drawnBonusMinimumNumber, lottery.drawnBonusMaximumNumber);
            } while (Enumerable.from(ticket.bonus).contains(number));
            ticket.bonus.push(number);
        }
        this.updateTicketNumbers();
    };
    BaseBundle.prototype.pickRandom = function (ticket, key) {
        this.pickRandomInternal(ticket, key);
        this.save(ticket, key);
    };
    BaseBundle.prototype.save = function (ticket, brandLotteryId, force) {
        var _this = this;
        if (force === void 0) { force = false; }
        if (!this.canRevert || force) {
            var request = this.getCreateTicketRequest(ticket, brandLotteryId);
            if (this.validateRequest(request)) {
                this.gamePlayerTicketClientService.createOrModifyTicket(request).catch(function (x) {
                    _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
                });
            }
        }
    };
    BaseBundle.prototype.getCreateTicketRequest = function (ticket, brandLotteryId) {
        var selectedDiscount = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isSelected; });
        var selectedDraw = selectedDiscount.numberOfDraws;
        if (selectedDiscount.isMonthlySubscription) {
            var bundleBrandLottery = Enumerable.from(this.bundle.bundleBrandLotteries).firstOrDefault(function (x) { return x.brandLotteryId == brandLotteryId; });
            selectedDraw = bundleBrandLottery ? bundleBrandLottery.numberOfDraws : 0;
        }
        return {
            bundleGuid: this.getRemainingNumbers(ticket, brandLotteryId) == 0 ? this.bundleGuid : null,
            cartGuid: this.getRemainingNumbers(ticket, brandLotteryId) == 0 ? this.cartGuid : null,
            sequenceNumber: this.tickets[brandLotteryId].indexOf(ticket),
            bonusPicks: ticket.bonus.join(","),
            mainPicks: ticket.main.join(","),
            ticketGuid: ticket.guid,
            ticketId: ticket.ticketId,
            brandLotteryId: brandLotteryId,
            draws: selectedDraw,
            recordedSessionId: Client.RECORDING_SESSION_ID,
            isFromCart: this.isFromCart,
            bundleId: this.bundle.bundleId,
            subscriptionMonths: selectedDiscount ? selectedDiscount.subscriptionMonths : null,
        };
    };
    BaseBundle.prototype.getRemainingNumbers = function (ticket, brandLotteryId) {
        return this.getRemainingMain(ticket, brandLotteryId) + this.getRemainingBonus(ticket, brandLotteryId);
    };
    BaseBundle.prototype.getRemainingBonus = function (ticket, brandLotteryId) {
        var lottery = Enumerable.from(this.bundleLotteries).firstOrDefault(function (x) { return x.brandLotteryId == brandLotteryId; });
        if (lottery)
            return lottery.drawnBonusNumbers - ticket.bonus.length;
        return 0;
    };
    BaseBundle.prototype.getRemainingMain = function (ticket, brandLotteryId) {
        var lottery = Enumerable.from(this.bundleLotteries).firstOrDefault(function (x) { return x.brandLotteryId == brandLotteryId; });
        if (lottery)
            return lottery.drawnNumbers - ticket.main.length;
        return 0;
    };
    BaseBundle.prototype.validateRequest = function (request) {
        var draws = Enumerable.from(this.discountOffers).any();
        if (!draws) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-no-draws-set-up"), "", NotificationType.Warning);
            return false;
        }
        else if (request && request.draws <= 0) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-select-draw-number"), "", NotificationType.Warning);
            return false;
        }
        else if (!this.ticketPrice) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-prices-not-set-for-your-currency"), "", NotificationType.Warning);
            return false;
        }
        return true;
    };
    BaseBundle.prototype.getRandom = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    };
    BaseBundle.prototype.getLotteryById = function (key) {
        return Enumerable.from(this.bundleLotteries).firstOrDefault(function (x) { return x.brandLotteryId == key; });
    };
    BaseBundle.prototype.shouldDeleteTicketOnMobile = function () {
        return true;
    };
    BaseBundle.prototype.updateTicketNumbers = function () {
        this.bindingSignaler.signal('update-selected-ticket-numbers');
        this.updateTotalPrice();
    };
    BaseBundle.prototype.updateTotalPrice = function () {
        this.bindingSignaler.signal('selected-offer-signal');
    };
    BaseBundle.prototype.getSelectedOffer = function () {
        var selected = Enumerable.from(this.discountOffers).firstOrDefault(function (x) { return x.isSelected; });
        return selected;
    };
    BaseBundle.prototype.calculateTotalLines = function () {
        var _this = this;
        var numberOfLines = Enumerable.from(this.tickets).any() ? Enumerable.from(this.tickets).sum(function (x) {
            return Enumerable.from(x.value).count(function (ticket) { return _this.getRemainingNumbers(ticket, Number(x.key)) === 0; });
        }) : 0;
        return numberOfLines;
    };
    BaseBundle.prototype.getStandardTicketPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(this.ticketPrice.price).toFixed(2);
        }
        return "";
    };
    BaseBundle.prototype.roundToTwoDecimalPlaces = function (x) {
        // 0.075 with the .toFixed does not round correctly
        return Math.round(x * 100) / 100;
    };
    BaseBundle.prototype.calculateTotalPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var selectedOffer = this.getSelectedOffer();
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            var total = this.roundToTwoDecimalPlaces(this.getDiscountedPrice());
            var discounted = total;
            if (selectedOffer)
                discounted = selectedOffer.isMonthlySubscription ? (total * selectedOffer.subscriptionMonths) : total * selectedOffer.numberOfDraws;
            return ticketCurrency.symbol + discounted.toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseBundle.prototype.getDiscountedPrice = function () {
        var ticketPicks = this.bundle.numberOfLines;
        var discount = this.getSelectedOffer() ? this.getSelectedOffer().discount : 0;
        return (this.roundToTwoDecimalPlaces(this.calculateDiscountedPrice(discount, this.ticketPrice) * ticketPicks));
    };
    BaseBundle.prototype.calculateDiscountedPrice = function (discount, priceModel) {
        var roundedPrice = priceModel.price;
        var discountedRoundedPrice = roundedPrice - this.roundToTwoDecimalPlaces((roundedPrice * discount) / 100);
        return discountedRoundedPrice;
    };
    BaseBundle.prototype.calculateCurrentDiscountedTicketPrice = function () {
        var currentOffer = this.getSelectedOffer();
        var discountedRoundedPrice = this.calculateDiscountedPrice(this.getSelectedOffer().discount, this.ticketPrice);
        var monthlyBundlePrice = currentOffer.isMonthlySubscription ? (discountedRoundedPrice * currentOffer.subscriptionMonths) : (discountedRoundedPrice * currentOffer.numberOfDraws);
        return this.roundToTwoDecimalPlaces(monthlyBundlePrice).toFixed(2);
    };
    Object.defineProperty(BaseBundle.prototype, "anySelectedTickets", {
        get: function () {
            var _this = this;
            var anySelected = true;
            for (var key in this.tickets)
                anySelected = anySelected && Enumerable.from(this.tickets[key])
                    .any(function (x) { return _this.getRemainingBonus(x, Number(key)) == 0 && _this.getRemainingMain(x, Number(key)) == 0; });
            return anySelected;
        },
        enumerable: false,
        configurable: true
    });
    BaseBundle.prototype.calculateDiscountedTicketPrice = function (discountModel) {
        var discountedRoundedPrice = this.calculateDiscountedPrice(discountModel.discount, this.ticketPrice);
        var finalPrice = Math.round(discountedRoundedPrice * 100) / 100;
        return this.tokenClient.getCurrencySymbol() + this.roundToTwoDecimalPlaces(finalPrice).toFixed(2);
    };
    BaseBundle.prototype.editTicket = function (ticket, lottery) {
        this.dialogClient.show(clientComponentModuleId("dialogs/choose-numbers-dialog"), {
            ticket: ticket,
            lottery: lottery,
            bundleId: this.bundleId,
            bundleKey: this.key
        }, true, true);
        var navHeight = $(".common-navigation-menu")[0] ? $(".common-navigation-menu")[0].clientHeight : 0;
        var chooseTicketHeight = $("choose-ticket").height() + navHeight;
        this.sendHeightToClient(chooseTicketHeight + "px", true);
    };
    Object.defineProperty(BaseBundle.prototype, "showAddToCartButton", {
        get: function () {
            return !this.bundle.isPromotion;
        },
        enumerable: false,
        configurable: true
    });
    BaseBundle.prototype.buyTickets = function (clientDetails) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (_this.isBuyingTickets) {
                reject();
                return;
            }
            var requests = Enumerable.from(_this.tickets).where(function (x) {
                var any = Enumerable.from(x.value).any(function (a) { return _this.getRemainingBonus(a, Number(x.key)) == 0 && _this.getRemainingMain(a, Number(x.key)) == 0; });
                return any;
            }).selectMany(function (x) {
                var lotteryTickets = Enumerable.from(x.value).select(function (a) { return _this.getCreateTicketRequest(a, Number(x.key)); });
                return lotteryTickets;
            })
                .toArray();
            if (requests.length <= 0) {
                _this.noTicketsToPurchase();
            }
            else {
                if (_this.tokenClient.isAgent() && !clientDetails) {
                    _this.showClientDetailsDialog();
                    resolve(undefined);
                }
                else {
                    _this.isUnauthorized = false;
                    _this.isBuyingTickets = true;
                    if (_this.validateRequest(requests[0]))
                        _this.gamePlayerTicketClientService.purchaseTickets({
                            tickets: requests,
                            purchasedFromCart: false,
                            clientDetails: clientDetails,
                            gameIdentifier: _this.bundle.gameIdentifier
                        }).then(function (x) {
                            var e_5, _a;
                            _this.isBuyingTickets = false;
                            try {
                                for (var requests_1 = __values(requests), requests_1_1 = requests_1.next(); !requests_1_1.done; requests_1_1 = requests_1.next()) {
                                    var request = requests_1_1.value;
                                    var key = request.brandLotteryId;
                                    var ticket = Enumerable.from(_this.tickets[key]).firstOrDefault(function (x) { return x.guid == request.ticketGuid; });
                                    var index = _this.tickets[key].indexOf(ticket);
                                    _this.tickets[key].splice(index, 1);
                                    _this.tickets[key].push(_this.getNewTicket());
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (requests_1_1 && !requests_1_1.done && (_a = requests_1.return)) _a.call(requests_1);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                            _this.updateTicketNumbers();
                            if (!_this.tokenClient.isAgent()) // do not redirect if is agent since we show the ticket
                                _this.navigateToLobby();
                            _this.notificationClientService.show(_this.i18n.tr("purchased-tickets-successfully-title"), _this.i18n.tr("purchased-tickets-successfully-message"), NotificationType.Success);
                            _this.onPurchase();
                            resolve(x);
                        }, function (x) {
                            _this.isUnauthorized = x && x.statusCode == 401 && !_this.tokenClient.user.enableLoginDialog;
                            if (x && !_this.isUnauthorized)
                                _this.notificationClientService.show(_this.i18n.tr("notification-error-title"), _this.i18n.tr(x.response), NotificationType.Error);
                            _this.isBuyingTickets = false;
                            reject();
                        });
                    else {
                        _this.isBuyingTickets = false;
                        reject();
                    }
                }
            }
        });
    };
    BaseBundle.prototype.addToCart = function () {
        var _this = this;
        if (this.isAddingToCart)
            return;
        this.isAddingToCart = true;
        var requests = Enumerable.from(this.tickets).where(function (x) {
            var any = Enumerable.from(x.value).any(function (a) { return _this.getRemainingBonus(a, Number(x.key)) == 0 && _this.getRemainingMain(a, Number(x.key)) == 0; });
            return any;
        }).selectMany(function (x) {
            var lotteryTickets = Enumerable.from(x.value).select(function (a) { return _this.getCreateTicketRequest(a, Number(x.key)); });
            return lotteryTickets;
        })
            .toArray();
        if (!this.tokenClient.isAuthenticated) {
            this.notificationClientService.show(this.i18n.tr(this.key + "-not-authenticated-message"), this.i18n.tr(this.key + "-add-to-cart-not-logged-in-notification-message"), NotificationType.Warning);
        }
        if (requests.length <= 0) {
            this.isAddingToCart = false;
            this.noTicketsAddedToCart();
        }
        else {
            if (this.validateRequest(requests[0]))
                this.gamePlayerTicketClientService.addTicketsToCart({
                    tickets: requests
                }).then(function (x) {
                    var e_6, _a;
                    _this.isAddingToCart = false;
                    try {
                        for (var requests_2 = __values(requests), requests_2_1 = requests_2.next(); !requests_2_1.done; requests_2_1 = requests_2.next()) {
                            var request = requests_2_1.value;
                            var key = request.brandLotteryId;
                            var ticket = Enumerable.from(_this.tickets[key]).firstOrDefault(function (x) { return x.guid == request.ticketGuid; });
                            var index = _this.tickets[key].indexOf(ticket);
                            _this.tickets[key].splice(index, 1);
                            _this.tickets[key].push(_this.getNewTicket());
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (requests_2_1 && !requests_2_1.done && (_a = requests_2.return)) _a.call(requests_2);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                    _this.updateTicketNumbers();
                    _this.router.navigateToRoute(RouterConstants.RouteNames.Cart);
                    _this.eventAggregator.publish(Client.UpdateCartCount);
                    _this.ticketsAddedToCart();
                    window.dataLayer.push({
                        "event": "navigate_to_cart",
                        "bundleId": _this.bundleId,
                        "openedBundleName": _this.bundle.bundleName,
                        "openedBundleId": _this.bundle.bundleId,
                    });
                    _this.onAddedToCart();
                }, function (x) {
                    _this.isAddingToCart = false;
                });
            else
                this.isAddingToCart = false;
        }
    };
    BaseBundle.prototype.update = function () {
        var _this = this;
        if (this.isUpdating)
            return;
        this.isUpdating = true;
        this.saveBulk(this.tickets, true).then(function (x) {
            _this.isUpdating = false;
            _this.router.navigateToRoute(RouterConstants.RouteNames.Cart);
            _this.eventAggregator.publish(Client.UpdateCartCount);
            _this.updatedCart();
            window.dataLayer.push({
                "event": "navigate_to_cart",
                "bundleId": _this.bundleId,
                "openedBundleName": _this.bundle.bundleName,
                "openedBundleId": _this.bundle.bundleId,
            });
        }, function (x) {
            _this.isUpdating = false;
            _this.notificationClientService.show("Error", _this.i18n.tr(x.response), NotificationType.Error);
        });
    };
    BaseBundle.prototype.getNewTicket = function () {
        return {
            guid: Guid.generateGuid(),
            main: [],
            bonus: []
        };
    };
    BaseBundle.prototype.onPurchase = function () { };
    BaseBundle.prototype.onAddedToCart = function () { };
    BaseBundle.prototype.showClientDetailsDialog = function () {
        this.dialogClient.show(clientComponentModuleId("common/client-details-dialog"), this, false, true);
    };
    BaseBundle.prototype.updatedCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-updated-cart"), "", NotificationType.Success);
    };
    BaseBundle.prototype.noTicketsToPurchase = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-no-tickets-to-purchase"), "", NotificationType.Warning);
    };
    BaseBundle.prototype.noTicketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-no-tickets-to-add-to-cart"), "", NotificationType.Warning);
    };
    BaseBundle.prototype.ticketsAddedToCart = function () {
        this.notificationClientService.show(this.i18n.tr(this.key + "-tickets-added-to-cart"), "", NotificationType.Success);
    };
    BaseBundle.prototype.calculateTotalPriceWithoutDiscountInternal = function () {
        return this.roundToTwoDecimalPlaces(this.ticketPrice.price);
    };
    BaseBundle.prototype.calculateTotalDiscountPrice = function () {
        var _this = this;
        if (this.ticketPrice) {
            var currentOffer = this.getSelectedOffer();
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            var discountAmt = this.calculateTotalPriceWithoutDiscountInternal() - this.getDiscountedPrice();
            var mnthlyDiscountAmt = discountAmt;
            if (currentOffer)
                mnthlyDiscountAmt = currentOffer.isMonthlySubscription ? discountAmt * currentOffer.subscriptionMonths : discountAmt;
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(mnthlyDiscountAmt).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    BaseBundle.prototype.calculateTotalPriceWithoutDiscount = function () {
        var _this = this;
        if (this.ticketPrice) {
            var currentOffer = this.getSelectedOffer();
            var ticketCurrency = Enumerable.from(this.tokenClient.currencies).firstOrDefault(function (x) { return x.currencyId == _this.ticketPrice.currencyId; });
            var monthlyTotal = this.calculateTotalPriceWithoutDiscountInternal();
            if (currentOffer)
                monthlyTotal = currentOffer.isMonthlySubscription ? this.calculateTotalPriceWithoutDiscountInternal() * currentOffer.subscriptionMonths
                    : this.calculateTotalPriceWithoutDiscountInternal();
            return ticketCurrency.symbol + this.roundToTwoDecimalPlaces(monthlyTotal).toFixed(2);
        }
        return this.tokenClient.getCurrencySymbol() + "0.00";
    };
    __decorate([
        computedFrom("key"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseBundle.prototype, "cssKey", null);
    __decorate([
        computedFrom("bundle.isPromotion"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], BaseBundle.prototype, "showAddToCartButton", null);
    return BaseBundle;
}(BaseTemplate));
export { BaseBundle };
